import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, BUTTON_TYPES, Card } from '_atoms';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { getUser } from 'store/selectors/authorizeSelectors';
import history from 'helpers/history';
import { ROUTES } from 'router/constants';
import './style.scss';

export const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector(getUser);

  useEffect(() => {
    if (!window.localStorage.getItem('access_token') && !user) {
      window.localStorage.setItem('link_to_page', window.location.pathname);
    }
  }, []);

  const buttonClickHandler = () => {
    if (!!window.localStorage.getItem('access_token') && !!user) history.push(ROUTES.DASHBOARD);
    else history.push(ROUTES.LOGIN);
  };

  return (
    <div className="not-found-page">
      <Card className="not-found-card">
        <Typography.Title3 weight={TYPOGRAPHY_WEIGHT.BOLD}>{t('translation:not_found.title')}</Typography.Title3>
        <Typography.Text>{t('translation:not_found.text_old_version')}</Typography.Text>
        <Button type={BUTTON_TYPES.PRIMARY} onClick={buttonClickHandler}>
          {t('translation:not_found.button_go_to_dashboard')}
        </Button>
      </Card>
    </div>
  );
};
